import { StringHelpers } from "../helpers/string-helpers";
import { IChartContainer } from "../models/base/chart-container.interface";
import { DrawOrderExecutionModel } from "../models/draw-trade-order/draw-order-execution.model";
import { IComponent } from "./component.interface";

export class DrawOrderExecutionComponent implements IComponent {
    public id = '';

    private element: HTMLElement | null = null;
    private base: IChartContainer;
    private model: Array<DrawOrderExecutionModel> = [];
    private isRemovingForSwitchingSymbol = false;

    constructor(base: IChartContainer) {
        this.id = StringHelpers.newGuid();
        this.base = base;
        this.base.tiChartSeries?.subscribeExtremeChange(() => {
            setTimeout(() => {
                this.draw();
            }, 50);
        });
        this.base.tiChartSeries?.subscribeRedrawChange(() => {
            setTimeout(() => {
                this.draw();
            }, 50);
        });
        this.subscribeDrawOrderExecutionData();
    }

    public createElement() {
        const div = document.createElement('div');
        div.classList.add('draw-order-execution');
        
        const highchartContainer = this.base.tiChartSeries.element.findFirst('.highcharts-container');
        if (highchartContainer) {
            highchartContainer.insertAdjacentElement('beforeend', div);
            this.element = div;
            this.isRemovingForSwitchingSymbol = false;
        }
    }

    public remove() {
        this.isRemovingForSwitchingSymbol = true;
        this.element?.setInnerHtml('');
        this.element?.remove();
        this.model = [];
    }

    private subscribeDrawOrderExecutionData() {
        this.base.chartService.subscribeDrawOrderExecutionData((model: Array<DrawOrderExecutionModel>) => {
            if (this.isRemovingForSwitchingSymbol) {
                return;
            }

            this.model = model;
            this.draw();
        });

        // setTimeout(() => {
        //     this.model = [
        //         new DrawOrderExecutionModel({
        //             tooltip: 'test',
        //             symbol: 'SPY',
        //             imageAnnotationName: 'EXECUTION_BUY_LIGHT',
        //             x: 345,
        //             y: 418.5
        //         })
        //     ]

        //     this.draw();
        // }, 5000);
    }

    // private isDraw = false;
    private draw() {
        if (this.isRemovingForSwitchingSymbol || !this.element || !this.base.tiChartSeries || !this.model?.length) {
            return;
        }
        
        // if (this.isDraw) {return;}

        this.element.setInnerHtml('');

        // const previousElement = this.element.findFirst('.doe-' + this.id);
        // previousElement?.remove();

        for (const item of this.model) {
            const xValue = Math.round(item.x);
            const mainChartSerie: any = this.base.tiChartSeries.highStockChart.series[0];
            const yAxis = this.base.tiChartSeries.highStockChart.yAxis[0];
            const xAxis = this.base.tiChartSeries.highStockChart.xAxis[0];
            if (!mainChartSerie || !yAxis || !xAxis || item.symbol != this.base.tiChartSeries.symbol|| !mainChartSerie.processedXData.some((x: number) => x == xValue)) {
                continue;
            }
    
            const imageAndClass = item.getImageAndClass(this.base.basePath);
            const image = imageAndClass[0];
            const className = imageAndClass[1];
    
            let top = this.base.tiChartSeries?.hasAnyComparisonSymbols() ? 53 : 33;
            let left = 0;
    
            top += yAxis?.toPixels(item.y, true);
            if (className == 'right') {
                left = xAxis?.toPixels(xValue, true) + 24;
            } else if (className == 'left') {
                left = xAxis?.toPixels(xValue, true) + 46;
            }
    
            const div = `<div class="doe doe-${this.id} ${className}" style="top:${top.toFixed(2)}px; left:${left.toFixed(2)}px;" title="${item.tooltip}">
                <img src="${image}" alt="draw order image" />
            </div>`;
            
            this.element.insertAdjacentHTML('beforeend', div);
        }

        // this.isDraw = true;
    }
}